.container {
    width: 320px;
    max-width: 320px;
}
